import React from 'react';
import { useParams } from 'react-router-dom';
import { useCart } from '../context/CartContext';
export function Collection() {
  const {
    addToCart
  } = useCart();
  const {
    category
  } = useParams();
  const title = category?.replace(/-/g, ' ') || 'Collection';
  const collectionImages = ['https://cdn.magicpatterns.com/uploads/jEej3XExu4hp2w3M59neD7/image.png', 'https://cdn.magicpatterns.com/uploads/pyPQ371b8FAGqP4T9JAg1g/image.png', 'https://cdn.magicpatterns.com/uploads/d353YWp21zZqnC3Pek7CAu/image.png', 'https://cdn.magicpatterns.com/uploads/bNzipinq9iBsE8CPGtTcf7/image.png', 'https://cdn.magicpatterns.com/uploads/hKWnidCpo3bKaJQkESyfZm/image.png'];
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-516">
      <div className="max-w-[1800px] mx-auto" data-id="element-517">
        <header className="mb-20 text-center" data-id="element-518">
          <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-519">
            Shop
          </span>
          <h1 className="text-2xl sm:text-4xl md:text-6xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase mb-6" data-id="element-520">
            {title}
          </h1>
          <p className="max-w-xl mx-auto text-sm md:text-base font-light tracking-widest text-black/60 leading-relaxed uppercase" data-id="element-521">
            Discover our curated selection of {title}. High-fashion
            craftsmanship meets cultural heritage.
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8" data-id="element-522">
          {collectionImages.map((img, i) => <div key={i} className="group" data-id="element-523">
              <div className="aspect-[3/4] bg-grey-divider overflow-hidden mb-4 relative" data-id="element-524">
                <img src={img} alt={`Product ${i + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-525" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center opacity-0 group-hover:opacity-100" data-id="element-526">
                  <button onClick={() => addToCart({
                id: `${category}-${i}`,
                name: `${title} Piece ${String(i + 1).padStart(2, '0')}`,
                price: '$240.00',
                image: img,
                quantity: 1,
                size: 'OS'
              })} className="bg-white text-black px-6 py-3 text-xs font-display font-bold uppercase tracking-widest hover:bg-black hover:text-white transition-colors" data-id="element-527">
                    Add to Bag
                  </button>
                </div>
              </div>
              <div className="flex justify-between items-start" data-id="element-528">
                <div data-id="element-529">
                  <h3 className="text-xs md:text-sm font-display font-bold tracking-widest uppercase mb-1" data-id="element-530">
                    {title} Piece {String(i + 1).padStart(2, '0')}
                  </h3>
                  <p className="text-sm font-light text-black/50" data-id="element-531">$240.00</p>
                </div>
                <button onClick={() => addToCart({
              id: `${category}-${i}`,
              name: `${title} Piece ${String(i + 1).padStart(2, '0')}`,
              price: '$240.00',
              image: img,
              quantity: 1,
              size: 'OS'
            })} className="md:hidden text-xs font-display font-bold uppercase tracking-widest border-b border-black pb-0.5" data-id="element-532">
                  Add to Bag
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}